import * as yup from "yup";

export const ProductCodes = [
  "SmartApply",
  "Survey",
  "BoothReserve",
  "MadoguchiEditor",
  "TtzkGuide",
  "AIStudio",
  "Portal",
  "Call",
  "KintoneExport",
  "ServiceAccount",
  "NinteiShoukai",
] as const;
export type ProductCodeTypeLiterals = (typeof ProductCodes)[number];
export const ProductNameMap: { [k in ProductCodeTypeLiterals]: string } = {
  SmartApply: "Graffer スマート申請",
  Survey: "Graffer アンケート",
  BoothReserve: "Graffer 窓口予約",
  MadoguchiEditor: "Graffer 窓口書類作成",
  TtzkGuide: "Graffer 手続きガイド",
  AIStudio: "Graffer AIStudio",
  Portal: "Graffer ポータル",
  Call: "Graffer コール",
  KintoneExport: "スマート申請の申請データを kintone へ転送",
  ServiceAccount: "サービスアカウント",
  NinteiShoukai: "要介護認定照会システム",
} as const;

export const Plans = [
  "SelfServe",
  "Package",
  "Free",
  "Light",
  "Standard",
  "Advanced",
  "CMSOnly",
  "NotSet",
] as const;
export type PlanTypeLiterals = (typeof Plans)[number];
export const PlanNameMap: { [k in PlanTypeLiterals]: string } = {
  SelfServe: "セルフサーブ",
  Package: "パッケージ",
  Free: "フリー",
  Light: "ライト",
  Standard: "スタンダード",
  Advanced: "アドバンス",
  CMSOnly: "CMS",
  NotSet: "設定なし",
} as const;

export const ProductPlanMap: {
  [k in ProductCodeTypeLiterals]: PlanTypeLiterals[];
} = {
  SmartApply: ["SelfServe", "Package", "NotSet"],
  Survey: ["SelfServe", "NotSet"],
  BoothReserve: ["SelfServe", "NotSet"],
  MadoguchiEditor: ["SelfServe", "Package", "NotSet"],
  TtzkGuide: ["SelfServe", "NotSet"],
  AIStudio: ["SelfServe", "NotSet"],
  Portal: ["Free", "Light", "Standard", "NotSet"],
  Call: ["SelfServe", "NotSet"],
  KintoneExport: ["SelfServe", "Package", "NotSet"],
  ServiceAccount: ["SelfServe", "Package", "NotSet"],
  NinteiShoukai: ["SelfServe", "NotSet"],
};

export type OrgProductRawType = {
  id: string;
  orgId: string;
  productCode: ProductCodeTypeLiterals;
  plan: PlanTypeLiterals;
  legalTermUrl: string;
};

export type OrgProductType = OrgProductRawType & {
  productName: string;
  planName: string;
};

export const isOrgProduct = (
  p: Partial<OrgProductType>,
): p is OrgProductType => {
  try {
    yup.string().url().validateSync(p.legalTermUrl);
  } catch {
    return false;
  }

  return (
    !!p.orgId &&
    !!p.productCode &&
    ProductCodes.includes(p.productCode) &&
    !!p.plan &&
    Plans.includes(p.plan) &&
    p.legalTermUrl !== undefined
  );
};

export const supplementOrgProductNames = (
  raw: OrgProductRawType,
): OrgProductType => ({
  ...raw,
  productName: ProductNameMap[raw.productCode],
  planName: PlanNameMap[raw.plan],
});
